import React, { useEffect, useState } from "react";
import { Card, Table, Tooltip } from "antd";
import ReportsFilter from "./ReportsFilter";
import CommonTblHeader from "components/common/CommonTblHeader";
import ToastMsg from "components/common/ToastMsg";
import useApiData from "components/common/useGetApiData";
import { getMonthWiseAttendanceReportsPagination } from "hooks/api/reportsApi.js";
import { MONTH_WISE_ATTENDANCE_REPORTS } from "constants";
import { EmployeeDetails } from "components/common/CommonComponent";
import dayjs from "dayjs";
import useApiMethods from "hooks/apiConfig/method/apiMethods";
import { MONTHWISE_ATTENDANCE_REPORTS } from "constant";

const initialData = {
  month_wise_month_year: new Date(),
  month_wise_designation: "",
  month_wise_department: "",
  month_wise_employee_grp: ""
}

function MonthWiseAttendance() {
  const authtoken = sessionStorage.getItem("token");
  const pageSize = 10;

  const [searchText, setSearchText] = useState("");
  const [dataUpdated, setDataUpdated] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [sorting, setSorting] = useState("");
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterDatas, setFilterDatas] = useState({ ...initialData });
  const [reorderedColumns, setReorderedColumns] = useState([]);
  const tableContainerHeight = "72vh";
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const parsedDate = selectedDate ? dayjs(selectedDate) : null;
  const [query, setQuery] = useState(`month=${parsedDate ? parsedDate.month() + 1 : ""}&year=${parsedDate ? parsedDate.year() : ""}&designation=${filterDatas.month_wise_designation ? filterDatas.month_wise_designation : ""}&department=${filterDatas.month_wise_department ? filterDatas.month_wise_department : ""}&employee_group=${filterDatas.month_wise_employee_grp ? filterDatas.month_wise_employee_grp : ""}`);

  useEffect(() => {
    if (!authtoken) {
      window.location.href = "/";
    }
  }, [authtoken]);

  // const [data, pageInfo, loading, _message, refetch] = useApiData(getMonthWiseAttendanceReportsPagination, {
  //   pageNo,
  //   pageSize,
  //   query,
  //   searchText,
  //   sorting,
  // });

  // useEffect(() => {
  //   if (_message && _message.isErrorMsg && _message.errorMsgText) {
  //     ToastMsg('error', _message.errorMsgText);
  //   }
  // }, [_message.errorMsgText]);

  const { fetch } = useApiMethods();
  const [data, setData] = useState([]);
  const [pageInfo, setPageInfo] = useState([])
  const [loading, setLoading] = useState(false);
  const [filter, setFilter]=useState({pageNo:'', pageSize:'', query:'', search:'', sorting:'', isDraft: ''})

  const fetchData = async () => {        
    const res = await fetch(
      MONTHWISE_ATTENDANCE_REPORTS, 
      filter,
      setLoading
    );
    if(res){
      if (res.status) {
        setData(res.data.result);
        setPageInfo({
          pageNo: res.data.page_no,
          pageSize: res.data.page_size,
          totalCount: res.data.total_count,
          noOfPages: res.data.no_of_pages,
        });
      }
    }
  };

  useEffect(() => {
    if (filter.query && authtoken) {
      fetchData();
    }
  }, [filter.query]);  

  useEffect(() => {
    if (!authtoken) {
      window.location.href = "/";
    }
  }, []); 

  useEffect(() => {
    const parsedDate = selectedDate ? dayjs(selectedDate) : null;
    const newQuery = `month=${parsedDate ? parsedDate.month() + 1 : ""}&year=${parsedDate ? parsedDate.year() : ""}&designation=${filterDatas.month_wise_designation ? filterDatas.month_wise_designation : ""}&department=${filterDatas.month_wise_department ? filterDatas.month_wise_department : ""}&employee_group=${filterDatas.month_wise_employee_grp ? filterDatas.month_wise_employee_grp : ""}`;
    setQuery(newQuery);
    setFilter((prevFilter) => ({
      ...prevFilter, 
      query: newQuery,
    }));
  }, [filterDatas]);

  // filter start
  const renderFilter = (data) => {
    //const parsedDate = data.month_wise_month_year ?? null;
    setFilterDatas((prevdata) => ({ ...prevdata, ...data }));
    setPageNo(1);
    // refetch(1,
    //   pageSize,
    //   `month=${parsedDate ? dayjs(filterDatas.month_wise_month_year).format('MM') : ""}&year=${parsedDate ? dayjs(filterDatas.month_wise_month_year).format('YYYY') : ""}&designation=${data.month_wise_designation ? data.month_wise_designation : ""}&department=${data.month_wise_department ? data.month_wise_department : ""}&employee_group=${data.month_wise_employee_grp ? data.month_wise_employee_grp : ""}`,
    //   searchText,
    //   sorting);
    setFilterVisible(false);
  }

  const ClosePopUp = () => {
    setFilterVisible(false);
  }

  const clearFilter = () => {
    setFilterDatas({...initialData});
    setPageNo(1);
    // refetch(1,
    //   pageSize,
    //   query,
    //   searchText,
    //   sorting);
  }
  //filter end

  const handleSearch = () => {
    setPageNo(1);
    setFilter((prevFilter) => ({
      ...prevFilter, 
      pageNo: 1, 
      pageSize: pageSize || prevFilter.pageSize, 
      query: queryString,
      search: searchText,
      sorting: sorting,
    }));
    setDataUpdated(!dataUpdated);
  }

  const handleTableChange = (pagination, filters, sorter) => {
    const sortorder = `sort=${sorter.order === "descend" ? "desc" : sorter.order === "ascend" ? "asc" : ""}&`
    const sortQuery = sorter.order ? `${sortorder}column=${sorter.columnKey}` : "";
    setFilter((prevFilter) => ({
      ...prevFilter, 
      pageNo: pagination.current, 
      pageSize: pagination.pageSize || prevFilter.pageSize, 
      query: query, 
      sorting: sortQuery,
    }));
    setSorting(sortQuery)
  }

  const columns = [
    {
      title: "Employee",
      dataIndex: "first_name",
      key: "employee__employee_name",
      width: "20%",
      sorter: true,
      fixed: 'left',
      render: (_, record) => {
        let empDetails = {
          ...record.employee,
          "designation_id": record?.employee.designation ? { id: record?.employee.designation.id, designation_name: record?.employee.designation.name } : { id: 0, designation_name: "" },
          "first_name": record?.employee.employee_name ? record?.employee.employee_name : "",
          "id": record?.employee.employee_id
        }
        return <EmployeeDetails details={empDetails} />;
      }
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
      sorter: true,
      render: (_, record) => (record?.year?.length > 28 ?
        <Tooltip title={record?.year}>{<span style={{ color: "black" }}>{record?.year?.slice(0, 25) + "..."}</span>}</Tooltip>
        : <p style={{ color: "black" }}>{record?.year ? record?.year : "-"}</p>),
      align: 'center',
      fixed: 'left',
    },
    {
      title: "Month",
      dataIndex: "month",
      key: "month",
      sorter: true,
      render: (_, record) => (record?.month?.length > 28 ?
        <Tooltip title={record?.month}>{<span style={{ color: "black" }}>{record?.month?.slice(0, 25) + "..."}</span>}</Tooltip>
        : <p style={{ color: "black" }}>{record?.month ? record?.month : "-"}</p>),
      align: 'center',
      fixed: 'left',
    },
    {
      title: "Department",
      key: "department",
      dataIndex: "department",
      sorter: true,
      ellipsis: true,
      width: "15%",
      fixed: 'left',
      render: (_, record) => (record?.department?.length > 28 ?
        <Tooltip title={record?.department}>{<span style={{ color: "black" }}>{record?.department?.slice(0, 25) + "..."}</span>}</Tooltip>
        : <p style={{ color: "black" }}>{record?.department ? record?.department : "-"}</p>),
    },
    {
      title: "Working Days",
      key: "working_days",
      dataIndex: "working_days",
      sorter: true,
      render: (_, record) => (record?.working_days?.length > 28 ?
        <Tooltip title={record?.working_days}>{<span style={{ color: "black" }}>{record?.working_days?.slice(0, 25) + "..."}</span>}</Tooltip>
        : <p style={{ color: "black" }}>{record?.working_days ? record?.working_days : "-"}</p>),
      align: 'right',
      fixed: 'right',
    },
    {
      title: "Present",
      key: "present",
      dataIndex: "present",
      sorter: true,
      render: (_, record) => (record?.present?.length > 28 ?
        <Tooltip title={record?.present}>{<span style={{ color: "black" }}>{record?.present?.slice(0, 25) + "..."}</span>}</Tooltip>
        : <p style={{ color: "black" }}>{record?.present ? record?.present : "-"}</p>),
      align: 'right',
      fixed: 'right',
    },
    {
      title: "Absent",
      key: "absent",
      dataIndex: "absent",
      sorter: true,
      render: (_, record) => (record?.absent?.length > 28 ?
        <Tooltip title={record?.absent}>{<span style={{ color: "black" }}>{record?.absent?.slice(0, 25) + "..."}</span>}</Tooltip>
        : <p style={{ color: "black" }}>{record?.absent ? record?.absent : "-"}</p>),
      align: 'right',
      fixed: 'right',
    },
  ];

  const handleFilter = () => {
    setFilterVisible(true)
  }

  const handleStateChanges = (search = "", reorderedList = []) => {
    setSearchText(search)
    setReorderedColumns(reorderedList)
  }

  const queryString =
    "?page_no=" + pageNo +
    "&page_size=" + pageSize +
    "&month=" + (parsedDate ? parsedDate.month() + 1  : "") +
    "&year=" + (parsedDate ? parsedDate.year() : "") +
    "&designation=" + (filterDatas.month_wise_designation ? filterDatas.month_wise_designation : "") +
    "&department=" + (filterDatas.month_wise_department ? filterDatas.month_wise_department : "") +
    "&employee_group=" + (filterDatas.month_wise_employee_grp ? filterDatas.month_wise_employee_grp : "") +
    "&search=" + searchText + (sorting ? `&${sorting}` : "");

  const styles = {
    fltContainer: {
      border: "1px solid #cbcbcb",
      height: tableContainerHeight,
    },
  }

  // Date changes start - Filter the data based on the selected date
  const handleDateChange = (date) => {
    setSelectedDate(date);
    setFilterDatas({ ...filterDatas, month_wise_month_year: date });
    setDataUpdated(!dataUpdated);
  };// Date changes end

  return (
    <Card className="h-full overflow-hidden">
      <div className={"h-1/6"}>
        <CommonTblHeader pageName={"Month-Wise Attendance Report"}
          pageInfo={pageInfo} handleSearch={handleSearch}
          onStateChange={handleStateChanges} handleFilter={handleFilter} columns={columns}
          url={MONTHWISE_ATTENDANCE_REPORTS} query={queryString}
          isAddRequired={false} isDraftRequired={false}
          isDateRequired={true} handleDateChange={handleDateChange} selectedDate={selectedDate}
          format="MMM YYYY" picker="month"
        />
      </div>
      <div className="relative h-5/6 mt-1">
        {filterVisible ?
          <div className="absolute w-1/4 z-10" style={{ ...styles.fltContainer, background: "white" }}>
            <ReportsFilter
              pageName={"Month-Wise Attendance Report"}
              filterDatas={filterDatas}
              closeFilter={ClosePopUp}
              filteredData={renderFilter}
              clearData={clearFilter} />
          </div>
          : null}
        <div className={"mt-5 w-full"} style={styles.fltContainer}>
          <Table
            columns={reorderedColumns?.length > 0 ? reorderedColumns : columns}
            dataSource={data?.length > 0 ? data : null}
            loading={loading}
            style={{ "--table-container-height": tableContainerHeight }}
            scroll={{ y: `calc(${tableContainerHeight} - 110px)` }}
            onChange={handleTableChange}
            pagination={{
              style: { marginRight: 20, padding: 0 },
              defaultPageSize: pageSize,
              showSizeChanger: false,
              showQuickJumper: true,
              total: pageInfo?.totalCount ? pageInfo?.totalCount : 0,
              pageSizeOptions: ["10", "20", "30"],
              pageSize,
              defaultCurrent: pageNo,
            }}
            key={dataUpdated ? "updated" : "not-updated"}
          />
        </div>
      </div>
    </Card>
  );
}

export default MonthWiseAttendance;